import { createActions } from 'redux-actions';
import types from 'state/mrCollection/ui/actionTypes';

const { mrCollection } = createActions({
  [types.SET_FETCHING]: (isFetching) => ({ isFetching }),
  [types.SET_SUBMITTING]: (isSubmitting) => ({ isSubmitting }),
});

export default mrCollection;
